export type State = {
  activeArticle: number;
  animating: boolean;
};

export type Action = {
  type: ActionTypes;
  item?: number;
  numItems?: number;
};

export enum ActionTypes {
  CLICK,
  NEXT,
  PREV
}
